import { CustomTooltip } from 'components/Labels'
import styled from 'styled-components'
import { PositionEnum } from 'types/cssTypes'
import { longTextTruncate } from 'utils/helper'

export const GridColumnLongNameToShort = (value: string | undefined, totalChar: number, params: any) => {
  if (!value) {
    return null
  }

  const convertedValue = longTextTruncate(value, totalChar)

  const rowIndex = params.node.rowIndex
  const api = params.api

  // Get the visible row count on current page
  let visibleRowsOnPage = 0
  api.forEachNodeAfterFilter((node: any) => {
    if (node.displayed) {
      visibleRowsOnPage++
    }
  })

  // Get current page info
  const currentPage = api.paginationGetCurrentPage()
  const pageSize = api.paginationGetPageSize()
  const firstRowOnPage = currentPage * pageSize
  const lastRowOnPage = firstRowOnPage + Math.min(pageSize, visibleRowsOnPage - firstRowOnPage)

  // Check if this is in the last 3 rows of the current page
  const isBottomRows = rowIndex >= lastRowOnPage - 3
  const tooltipPosition = isBottomRows ? PositionEnum.top : PositionEnum.bottom

  return (
    <Div>
      <CustomTooltip
        tooltipText={<TooltipContent>{value ? <div>{value}</div> : 'Not found'}</TooltipContent>}
        position={tooltipPosition}
        positionTooltipArrow={30}
        tooltipStyles={{
          maxWidth: '50rem',
          wordWrap: 'break-word',
          transform: 'translateX(-30%)',
          zIndex: 9999,
        }}
      >
        <div>{convertedValue ? convertedValue : '---'}</div>
      </CustomTooltip>
    </Div>
  )
}

const Div = styled.div`
  display: flex;
  gap: 0.5rem;
  white-space: nowrap;
  overflow: visible;
`

const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-width: 50rem;
  word-wrap: break-word;
`
